import CustomerInfoCard from 'components/CustomerInfoCard';
import useJobCustomer from './useJobCustomer';

const JobCustomer: React.FunctionComponent = function ({}) {
  const { customer, isLoading } = useJobCustomer();
  return <CustomerInfoCard customer={customer} isLoading={isLoading} />;
};

export default JobCustomer;
